export const UpcomingEventsArray = [
    require('../../images/drawer/Dashboard/up1.png'),
    require('../../images/drawer/Dashboard/up2.png'),
    require('../../images/drawer/Dashboard/up3.png'),
    require('../../images/drawer/Dashboard/up3.png')

];

export const WelcomeImagesArray = [
    require('../../images/drawer/Dashboard/welcomepic.png'),
    require('../../images/drawer/Dashboard/welcomepic2.png'),
    require('../../images/drawer/Dashboard/welcomepic3.png'),
];

export const UpcomingMeetingsObject = [
    {
        title: 'Parent Teacher Meeting',
        grade: 'Grade 11',
        teacherName: 'Jacob Jones',
        time: '10:00 AM',
        date: '24-Nov-2023'
    },
    {
        title: 'Final Result Meeting',
        grade: 'Grade 3',
        teacherName: 'Saad Mustafa',
        time: '02:00 AM',
        date: '29-Nov-2023'
    },
];

export const DocumentsArray = [
    {
        title: 'Rules And Regulation',
        pages: '14 pages',
        image: require('../../images/drawer/Dashboard/pdf.png')
    },
    {
        title: 'Physics',
        pages: '15 pages',
        image: require('../../images/drawer/Dashboard/pdf.png')
    },
    {
        title: 'Rules And Regulation',
        pages: '14 pages',
        image: require('../../images/drawer/Dashboard/pdf.png')
    },
    {
        title: 'chemistry',
        pages: '13 pages',
        image: require('../../images/drawer/Dashboard/pdf.png')
    }
];

export const NewsObject = [
    {
        title: 'User Group Meeting Confirmed',
        date: 'OCTOBER 2, 2024',
        image: 'https://getweeklyupdate.com/blog/wp-content/uploads/2018/02/1.jpg',
        description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolore adipisci enim in, et temporibus quos consectetur aperiam excepturi, facere quae laudantium asperiores! Cupiditate ut fugit voluptas, sint molestiae error similique?'
    },
    {
        title: 'User Group Meeting Confirmed',
        date: 'OCTOBER 2, 2024',
        image: 'https://getweeklyupdate.com/blog/wp-content/uploads/2018/02/1.jpg',
        description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolore adipisci enim in, et temporibus quos consectetur aperiam excepturi, facere quae laudantium asperiores! Cupiditate ut fugit voluptas, sint molestiae error similique?'
    },
    {
        title: 'User Group Meeting Confirmed',
        date: 'OCTOBER 2, 2024',
        image: 'https://getweeklyupdate.com/blog/wp-content/uploads/2018/02/1.jpg',
        description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolore adipisci enim in, et temporibus quos consectetur aperiam excepturi, facere quae laudantium asperiores! Cupiditate ut fugit voluptas, sint molestiae error similique?'
    },
    {
        title: 'User Group Meeting Confirmed',
        date: 'OCTOBER 2, 2024',
        image: 'https://getweeklyupdate.com/blog/wp-content/uploads/2018/02/1.jpg',
        description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolore adipisci enim in, et temporibus quos consectetur aperiam excepturi, facere quae laudantium asperiores! Cupiditate ut fugit voluptas, sint molestiae error similique?'
    },
];

